import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'
import { injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import messages from '../../../locale/messages';
import ToolTipContent from '../ToolTipContent/ToolTipContent';
import ShowPassword from '/public/Icons/pswVisible.svg';
import HidePassword from '/public/Icons/pwdHidden.svg';
import bt from '../../../components/commonStyle.css';
import s from './InputFieldComponent.css';

const InputFieldComponent = (props) => {
  const {
    input,
    label,
    inputClass,
    meta: { touched, error },
    type,
    isPassword,
    placeholder,
    showPassword,
    maxLength,
    disabled,
    toolTipText,
    note,
    labelNumber,
    componentClass,
    isAddon,
    onClick,
    suffixLabel,
    prefixLabel,
    showToolTip,
    chars_left,
    rows,
    labelClass,
    formGroupClass,
    readOnly,
    noColor,
    inputAddonContainer,
    intl: { formatMessage }
  } = props;

  if (isAddon) {
    return (
      <Form.Group className={cx(bt.space0, formGroupClass)} controlId={input.name}>
        {label && (
          <Form.Label className={cx(bt.commonLabelText, 'svgImg', labelClass)}>
            {label} {showToolTip && <ToolTipContent label={toolTipText} />}
          </Form.Label>
        )}
        <div className={cx(prefixLabel && "prefixInputAddonContainer", suffixLabel && "suffixInputAddonContainer", noColor && "noColorInputAddonContainer", inputAddonContainer)}>
          <InputGroup>
            {prefixLabel && <InputGroup.Prepend>
              <InputGroup.Text className='prefixAddonBtn'>
                {prefixLabel}</InputGroup.Text>
            </InputGroup.Prepend>
            }
            <Form.Control
              {...input}
              type={type}
              placeholder={placeholder}
              aria-label={!label ? (placeholder || input.name) : undefined}
              className={bt.formControlInput}
              disabled={disabled}
              maxLength={maxLength}
              onDragOver={event => {
                if (disabled) return;
                event.preventDefault();
              }}

              onDragEnter={(e) => {
                if (disabled) return;
                e.preventDefault();
              }}

              onDrop={(e) => {
                if (disabled) return;
                e.preventDefault();

              }}
              onChange={event => {
                if (disabled) return;
                input.onChange(event?.target?.value)
              }}
            />
            {suffixLabel && <InputGroup.Append>
              <InputGroup.Text className='suffixAddonBtn'>{suffixLabel}</InputGroup.Text>
            </InputGroup.Append>}
          </InputGroup>
        </div>
        {touched && error && <span className={bt.errorMessage}>{formatMessage(error)}</span>}
      </Form.Group>
    );
  }

  return (
    <Form.Group className={cx(bt.space0, formGroupClass)} controlId={input.name}>
      {label && (
        <Form.Label className={cx(bt.commonLabelText, 'svgImg', labelClass)}>
          {label} {labelNumber && <span>{labelNumber}</span>}
          {showToolTip && <ToolTipContent label={toolTipText} />}
        </Form.Label>
      )}
      <Form.Control
        {...input}
        type={showPassword === input.name ? input : type}
        placeholder={placeholder}
        aria-label={!label ? (placeholder || input.name) : undefined}
        className={inputClass}
        disabled={disabled}
        maxLength={maxLength}
        as={componentClass}
        rows={rows}
        readOnly={readOnly}
        onDragOver={event => {
          if (disabled) return;
          event.preventDefault();
        }}

        onDragEnter={(e) => {
          if (disabled) return;
          e.preventDefault();
        }}

        onDrop={(e) => {
          if (disabled) return;
          e.preventDefault();

        }}
        onChange={event => {
          if (disabled) return;
          input.onChange(event?.target?.value)
        }}
      />
      {type === 'password' && isPassword && (
        <span onClick={onClick} role="button" aria-label={showPassword === input.name ? 'Hide password' : 'Show password'} className={cx('commonPasswordIcon')}>
          {showPassword === input.name ? <img src={ShowPassword} alt="" /> : <img src={HidePassword} alt="" />}
        </span>
      )}

      {touched && error && <span className={bt.errorMessage}>{formatMessage(error)}</span>}
      {note && <p className={s.commonNoteText}>{note}</p>}
      {chars_left !== undefined && chars_left !== null && chars_left >= 0 && (
        <span className={bt.errorMessage}>
          {chars_left} {formatMessage(messages.maximumCharacterLeft)}
        </span>
      )}
    </Form.Group>
  );
};

InputFieldComponent.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object,
  label: PropTypes.string,
  type: PropTypes.string,
  intl: PropTypes.object.isRequired,
};

export default injectIntl(withStyles(bt, s)(InputFieldComponent));
